<div class="search-paginator">
  <mat-paginator
    class="search-paginator__paginator density--5"
    (page)="paginationChange($event)"
    [length]="searchContainer.searchResult?.search_count || 0"
    [pageIndex]="searchContainer.searchPage - 1"
    [pageSize]="searchContainer.rows"
    [pageSizeOptions]="searchContainer.searchResultViewName === viewNames.LIST ? [50, 100, 200, 500, 1000] : [50, 100, 200]"
    [showFirstLastButtons]="true"
  />
</div>
